import { render, staticRenderFns } from "./SelectTraverPoint.vue?vue&type=template&id=a5fabffc"
import script from "./SelectTraverPoint.vue?vue&type=script&lang=js"
export * from "./SelectTraverPoint.vue?vue&type=script&lang=js"
import style0 from "./SelectTraverPoint.vue?vue&type=style&index=0&id=a5fabffc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports